<template>
    <div class="account">
        <h2>Minha conta</h2>
        <div class="panel">
            <info></info>
            <address-form></address-form>
            <password></password>
        </div>
    </div>
</template>
<script>
import AddressForm from './Address.vue'
import Info from './Info.vue'
import Password from './Password.vue'
export default {
    name: "MyAccount",
    components: {
        AddressForm,
        Info,
        Password
    },
    data(){
        return {
            form: {
                address: {
                    country: '',
                    street: '',
                    number: '',
                    complement: '',
                    district: '',
                    city: '',
                    state: ''
                },
                personal: {
                    email: '',
                    name: ''
                },
                company: {
                    name: '',
                    document: '',
                    phone: ''
                },
                password: {
                    old: '',
                    new: '',
                    confirm: ''
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .account {
        background: #fcfcfc;
        padding: 30px;
    }
    h3{
        color: #000;
        font-weight: normal;
    }
    .panel{
        border-radius: 3px;
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 15px;
        border: 1px solid #ced2de;
        background: #fff;
        .panel-content{
            display: grid;
            grid-template-columns: 1fr 3fr;
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 1px solid #ced2de;
            &:last-child{
                border-bottom: none;
                margin-bottom: 0;
            }
        }
    }
    label{
        display: block;
        width: 100%;
        font-size: .83em;
        padding-bottom: 5px;
    }
    input, textarea{
        width: 100%;
        display: block;
        border: 1px solid rgba(160, 160, 160, 0.3);
        background: #fff;
        line-height: 28px;
        height: 28px;
        padding: 0 5px;
        border-radius: 2px;
    }
    .buttons{
        display: flex;
        justify-content: flex-end;
        button + button{
            margin-left: 5px
        }
    }
</style>